"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var mobx_1 = require("mobx");
var shared_1 = require("mad-utils/lib/shared");
/******************************************** LOGGING *********************************************/
var shared_2 = require("mad-logs/lib/shared");
var log = shared_2.logFactory('language-store.ts', shared_2.Styles.joy);
/**
 * Default language if no other default language is given
 */
var defaultDefaultLang = 'en';
/********************************************* EXPORT *********************************************/
/**
 * Store language data. General shape/props:
 *     language:    'en'          <-- Current language code
 *     languages:   ['en', 'fr']  <-- Array of supported languages
 *     defaultLang: 'en'          <-- Lang to default to if none set
 */
var LanguageStore = /** @class */ (function () {
    function LanguageStore(languages, initialLanguage, defaultLang) {
        if (languages === void 0) { languages = ['en', 'fr']; }
        if (initialLanguage === void 0) { initialLanguage = defaultDefaultLang; }
        if (defaultLang === void 0) { defaultLang = defaultDefaultLang; }
        var _this = this;
        this.defaultLang = defaultDefaultLang;
        this.language = defaultDefaultLang;
        this.languages = ['en', 'fr'];
        Object.keys(this).forEach(function (key) { return typeof _this[key] === 'function' && _this[key].bind(_this); });
        this.initialize(languages, initialLanguage, defaultLang);
        log.silly("LanguageStore#constructor :: this (on constructor exit):", this);
    }
    /**
     * Set initial values for language data
     */
    LanguageStore.prototype.initialize = function (languages, initialLanguage, defaultLang) {
        this.defaultLang = defaultLang;
        this.languages = languages;
        this.language = initialLanguage;
    };
    /**
     * Set current language
     * @param {string} language Current language
     */
    LanguageStore.prototype.setLanguage = function (language) {
        this.language = language || this.defaultLang;
        return this.language;
    };
    /**
     * Set full list of available languages
     */
    LanguageStore.prototype.setLanguages = function (languages) {
        this.languages = languages;
    };
    /**
     * Add new language to list of available languages
     */
    LanguageStore.prototype.addLanguage = function (language) {
        return shared_1.pushIfNew(this.languages, language);
    };
    /**
     * Remove language from list of available languages
     */
    LanguageStore.prototype.removeLanguage = function (language) {
        this.languages = this.languages.filter(function (lang) { return lang !== language; });
        return this.languages;
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], LanguageStore.prototype, "defaultLang", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], LanguageStore.prototype, "language", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], LanguageStore.prototype, "languages", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, String, String]),
        __metadata("design:returntype", void 0)
    ], LanguageStore.prototype, "initialize", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], LanguageStore.prototype, "setLanguage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], LanguageStore.prototype, "setLanguages", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Array)
    ], LanguageStore.prototype, "addLanguage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Array)
    ], LanguageStore.prototype, "removeLanguage", null);
    LanguageStore = __decorate([
        shared_1.singleton,
        __metadata("design:paramtypes", [Array, String, Object])
    ], LanguageStore);
    return LanguageStore;
}());
exports.LanguageStore = LanguageStore;
/***************************************** FACTORY EXPORT *****************************************/
/**
 * @export
 * LanguageStore factory. Build and return language store data
 */
exports.buildLanguageStore = mobx_1.action(function (props) {
    var languageStore = new LanguageStore(props.languages, props.language);
    log.info("buildLanguageStore :: languageStore:", languageStore);
    return languageStore;
});
//# sourceMappingURL=language-store.js.map